// Engine constants. All tuning lives here (config-driven), never scattered.

export const TOUR_CONFIG = {
  /** Padding (px) between the target and the spotlight cut-out edge. */
  spotlightPadding: 8,
  /** Corner radius (px) used for `rounded` spotlight shape / auto fallback. */
  spotlightRadius: 12,
  /** Gap (px) between the target and the popover. */
  popoverGap: 14,
  /** Viewport margin (px) the popover must never cross. */
  viewportMargin: 16,
  /** When the target overflows / has no room, pin the popover here. */
  overflowPin: { top: 32, right: 32 },
  /** Max time (ms) to wait for a step target to appear before giving up. */
  targetWaitTimeout: 8000,
  /** Poll/settle interval (ms) while waiting for a target. */
  targetPollInterval: 120,
  /** Z-index band — above Vuetify dialogs (2400) and toasts (3100). */
  zIndex: {
    spotlight: 3200,
    popover: 3210,
  },
  /** Motion (ms) — mirrors design-system duration tokens. */
  durations: {
    spotlight: 250,
    step: 250,
  },
} as const

/** localStorage key used by the persisted progress store. */
export const TOUR_STORAGE_KEY = 'tami_tour_progress'

/** Query param the AI assistant reads for the "Execute with AI" hand-off. */
export const AI_PROMPT_QUERY_PARAM = 'seed'
